<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Levélkészítés</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-card>
    <ion-card-header>
      <!--ion-card-title>Állománylista</ion-card-title-->
      <ion-row>
        <ion-col>
          <span style="font-size:25px;"></span>
          <span style="float:right">
        <ion-button id="open-modal"><fa-icon icon="plus" slot="start"></fa-icon>&nbsp;Új</ion-button>
      </span>
        </ion-col>
      </ion-row>
    </ion-card-header>
    <ion-card-content >
      <ion-list *ngIf="boritekok">
        <ion-item [button]="true" *ngFor="let boritek of boritekok; let idx = index">
          <ion-avatar aria-hidden="true" slot="start">
            <img alt="" src="https://ionicframework.com/docs/img/demos/avatar.svg" />
          </ion-avatar>
          <ion-label>Huey</ion-label>
          <div class="metadata-end-wrapper" slot="end">
            <ion-icon color="medium" name="chevron-forward"></ion-icon>
          </div>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>
</ion-content>
